import { useEffect, useState } from "react";
import { AppShell } from "@/components/AppShell";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, Empty, inr, fmtDate } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { HandCoins } from "lucide-react";

const ADV = { pending: "bg-amber-100 text-amber-800", approved: "bg-violet-100 text-violet-800", rejected: "bg-rose-100 text-rose-800", deducted: "bg-emerald-100 text-emerald-800" };

export default function AdvanceRequestPage() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ amount: "", reason: "" });
  const load = () => api.get("/hr/advances").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  async function submit() {
    try { await api.post("/hr/advances", { amount: Number(f.amount), reason: f.reason }); toast.success("Advance request sent to Admin"); setF({ amount: "", reason: "" }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  }
  return (
    <AppShell>
      <PageHeader eyebrow="HR" title="Advance Salary" subtitle="Request an advance. Once approved, it is deducted from your next salary." />
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-2xl shadow-sm p-5 space-y-3">
          <div><Label>Amount (₹)</Label><Input data-testid="adv-amount" type="number" min={1} value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} className="mt-1" /></div>
          <div><Label>Reason</Label><Textarea data-testid="adv-reason" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} className="mt-1" /></div>
          <Button data-testid="adv-submit" onClick={submit} disabled={!f.reason || Number(f.amount) <= 0} className="w-full btn-brand">Send request</Button>
        </div>
        <div>
          {rows.length === 0 ? <Empty testid="adv-empty" icon={HandCoins} text="No advance requests yet." /> : (
            <div className="bg-white rounded-2xl shadow-sm divide-y divide-slate-100">
              {rows.map((a) => (
                <div key={a.id} data-testid={`adv-${a.id}`} className="px-4 py-3 flex items-center gap-3">
                  <div className="flex-1"><div className="font-semibold">{inr(a.amount)}</div><div className="text-xs text-slate-500">{a.reason} • {fmtDate(a.created_at)}{a.deducted_month ? ` • deducted ${a.deducted_month}` : ""}</div></div>
                  <Badge className={`${ADV[a.status]} capitalize`}>{a.status}</Badge>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </AppShell>
  );
}
